import { HelpCircle } from "lucide-react";
import { useModuleHelpOptional } from "../../context/ModuleHelpContext";

export function ModuleHelpToggle() {
  const help = useModuleHelpOptional();
  if (!help) return null;

  const { panelEnabled, togglePanel } = help;

  return (
    <button
      type="button"
      onClick={togglePanel}
      className={`inline-flex items-center gap-1.5 px-3 py-2 rounded-xl border text-sm font-medium transition-colors shrink-0 ${
        panelEnabled
          ? "border-brand-primary/50 bg-brand-soft text-brand-primary"
          : "border-brand-soft bg-white text-brand-dark/65 hover:border-brand-primary/30 hover:text-brand-primary"
      }`}
      aria-pressed={panelEnabled}
      title={panelEnabled ? "Ocultar ayuda contextual" : "Mostrar ayuda contextual"}
    >
      <HelpCircle size={16} strokeWidth={2} />
      <span className="hidden sm:inline">Ayuda</span>
    </button>
  );
}
